(function(){

    class WinlineBatcherAllAtOnce {
        constructor(){

        }

        isCellDuplicate(cells, cell){
            for (let i = 0; i < cells.length; ++i){
                if ((cells[i].cell.reel === cell.reel) && (cells[i].cell.row === cell.row))
                    return true;
            }
            return false;
        }

        batch(wins, celebrationThreshold){
            let res = [];
            let isGreaterThanThreshold = wins.totalLineWinnings > celebrationThreshold;

            for (let i = 0; i < wins.winningLines.length; ++i){
                let win = wins.winningLines[i];

                for (let j = 0; j < win.positions.length; ++j){
                    if (this.isCellDuplicate(res, win.positions[j]))
                        continue;
                    let winData = {
                        cell: win.positions[j],
                        symbolId: win.symbol.ids[j],
                        winId: win.symbol.value,
                        celebrate: isGreaterThanThreshold,
                        winline: i
                    };
                    res.push(winData);
                }
            }

            return [res]; // batch all at once :)
        }
    };``

    let create = function(){
        return new WinlineBatcherAllAtOnce();
    }
    resourceManager.registerSharedPlugin("winlineBatcherAllAtOnceEx", create);
}());